import React from "react";
import {withRouter} from 'react-router-dom';
import ContactInfoShareBtn from "./components/contact-info-share-btn";
import ContactInfoEditBtn from "./components/contact-info-edit-btn";
import ContactInfoCommentBtn from "./components/contact-info-comment-btn";
import ContactInfoDeleteBtn from "./components/contact-info-delete-btn";
import './index.css';

function ContactInfoOptions ({contactDetails, location, history}) {
    return (
        <div className="d-flex align-items-center contact-info-options ml-3 my-3">
            <ContactInfoShareBtn/>
            <ContactInfoEditBtn contactDetails={contactDetails} history={history}/>
            <ContactInfoCommentBtn/>
            <ContactInfoDeleteBtn/>
        </div>
    )
}

export default withRouter(ContactInfoOptions);
